import {aiScoringStatus} from "@api";

export default {
  data(){
    return{
      aiScoring:{
        isAI: false, // 是否ai判分
        jump: true, // 能否跳转
        interval: null,
        timeout: null,
        pollingInterval: 10000, // 轮询间隔
        maxJumpTime: 30000, // 最大的跳转限制时间
        finished: false, // 是否判分完成
      }
    }
  },
  methods: {
    runAiScoring(data) {
      if (data.isAI !== 1) {
        return;
      }
      this.aiScoring.isAI = true;
      this.aiScoring.jump = false;
      this.aiScoring.timeout = setTimeout(() => this.aiScoring.jump = true, this.aiScoring.maxJumpTime);
      this.aiScoring.interval = setInterval(() => {
        if (this.aiScoring.jump) {
          clearInterval(this.aiScoring.interval);
          console.log("30秒未判分完成！")
        }
        aiScoringStatus(data.bizID).then(e => {
          if (e) {
            console.log("判分完成");
            this.aiScoring.finished = true;
            this.aiScoring.jump = true;
            clearTimeout(this.aiScoring.timeout);
            clearInterval(this.aiScoring.interval);
            this.aiScoring.timeout = null;
            this.aiScoring.interval = null;
          } else {
            console.log("判分中...")
          }
        });
      }, this.aiScoring.pollingInterval);
    },
  },
  beforeDestroy() {
    if (this.aiScoring.interval !== null) {
      clearInterval(this.aiScoring.interval);
    }
  }
}
